import React from "react";
import {getData} from "./util";
import {observableStore} from "./obvStore";

const x = {
    0: '万位',
    1: '千位',
    2: '百位',
    3: '十位',
    4: '个位',
    '': '开奖',
    form: '形态',
    total: '和值',
};
const x2 = {
    0: '百位',
    1: '十位',
    2: '个位',
    '': '开奖',
    form: '形态',
    total: '和值'
};
const x3 = {
    0: '冠军',
    1: '亚军',
    2: '季军',
    3: '第四',
    4: '第五',
    5: '第六',
    6: '第七',
    7: '第八',
    8: '第九',
    9: '第十',
    '': '开奖',
};
const x1 = {
    0: '一位',
    1: '二位',
    2: '三位',
    3: '四位',
    4: '五位',
    '': '开奖',
};
const fx = (c, i) => {
    const x = +c[i];
    if (x === 0) return <i/>;
    return x;
};
const fx1 = c => {
    const x = +c;
    if (x === 0) return <i/>;
    return x;
};
const y = {
    issue: '期号',
    lottery: '开奖号码',
    leopard: '豹子',
    three_cont: ['三连号', c => c],
    group_three: ['组三', fx],
    all_diff: ['三不同', fx],
    group_six: ['组六', fx],
    pair: '对子',
    span: '跨度',
    mantissa: '尾数和值',
    total_val: '和值',
    other_form: '012形态',
    bs_form: ['大小形态',
        /**
         * 表格cell数据变形
         * @param c 字段数据
         * @param i 当前索引
         * @return {*}
         */
            (c, i) => c[i].replace(/0/g, '大').replace(/1/g, '小')
    ],
    pc_form: ['质合形态', (c, i) => c[i].replace(/0/g, '合').replace(/1/g, '质')],
    oe_form: ['单双形态', (c, i) => c[i].replace(/0/g, '双').replace(/1/g, '单')],
};
const f = c => c + '期';
const f1 = c => {
    const a = c.replace('-', '');
    return a.substr(a.length - 4) + '期';
};
const iss = ['issue', f1];
const is = ['issue', f];
const star3 = (...k) => [
    ['', [is, lott(...k), 'leopard', 'group_three', 'group_six', 'span']],
    [[...k], [iss, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9]],
    ['form', [iss, 'bs_form', 'oe_form', 'pc_form', 'other_form']],
    ['total', [iss, 'total_val', 'mantissa']]
];
const lott = (...n) => [
    'lottery',
    c => c.map((v, i) => n.indexOf(i) !== -1 ?
        <b key={'v-' + i + '-' + v}>{v}</b> :
        <span key={'v-' + i + '-' + v}>{v}</span>)
];
const star2 = (...k) => [
    ['', [is, lott(...k), 'pair', 'span', 'total_val']],
    [[...k], [iss, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9]],
];
const xx = [iss, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const yy = ['', [is, lott(0, 1, 2, 3, 4, 5, 6, 7, 8, 9)]];

/**
 * View Func Object.
 * @typedef {[]} ViewFunc
 * @property {String|number} 0  - 字段名称
 * @property {function} 1       - 数据变形
 */

/**
 * View structure Object.
 * @typedef {[]} ViewDef
 * @property {String[],number[]|number|String} 0       - 二级目录名称
 * @property {ViewFunc[]|string[]|number[]} 1          - 列属性
 */

/**
 * View Config Object.
 * @typedef {Object} ViewConfig
 * @property {Object} k1       - 二级目录名称映射
 * @property {Object} k2       - 表格列数据类型映射
 * @property {[ViewDef]} data  - 顶部目录视图结构配置
 */
const config = {
    /**
     * @type {ViewConfig} ssc
     */
    ssc: {
        k1: x,
        k2: y,
        data: [
            /**
             * @type {ViewDef}
             */
            ['五星', [
                ['', [is, lott(0, 1, 2, 3, 4)]],
                [[0, 1, 2, 3, 4], [iss, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9]]
            ]],
            ['四星', [
                ['', [is, lott(1, 2, 3, 4)]],
                [[1, 2, 3, 4], [iss, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9]]
            ]],
            ['前三', star3(0, 1, 2)],
            ['中三', star3(1, 2, 3)],
            ['后三', star3(2, 3, 4)],
            ['前二', star2(0, 1)],
            ['后二', star2(3, 4)],
        ]
    },
    p35: {
        k1: x,
        k2: y,
        data: [
            ['三星', star3(0, 1, 2)],
        ]
    },
    pk10: {
        k1: x3,
        k2: {
            issue: '期号',
            lottery: '开奖号码',
        },
        data: [
            ['冠亚军', [
                yy,
                [[0, 1], xx],
            ]],
            ['前五名', [
                yy,
                [[0, 1, 2, 3, 4], xx]
            ]],
            ['后五名', [
                yy,
                [[5, 6, 7, 8, 9], xx]
            ]],
        ]
    },
    k3: {
        k1: x2,
        k2: {
            ...y,
            total_val: ['和值', (_, a, b = []) => {
                return b.reduce((c, d) => +c + (+d))
            }],
            pair: ['对子', (_, a, b = [], e) => {
                const m = {};
                for (let i = 0, l = b.length; i < l; i++) {
                    const n = b[i];
                    if ((m[n] = (m[n] + 1) || 1) === 2) {
                        e.v = 1;
                        return <i/>
                    }
                }
                return e.v++
            }],
            leopard: ['豹子', (_, a, b, e) => {
                const m = {};
                for (let i = 0, l = b.length; i < l; i++) {
                    const n = b[i];
                    if ((m[n] = (m[n] + 1) || 1) === 3) {
                        e.v = 1;
                        return <i/>
                    }
                }
                return e.v++
            }],
            all_diff: ['三不同', (_, a, b, e) => {
                const m = {};
                let ks = 0;
                for (let i = 0, l = b.length; i < l; i++) {
                    const n = b[i];
                    if (!m[n]) {
                        if (ks === 2) {
                            e.v = 1;
                            return <i/>
                        } else {
                            ks++;
                            m[n] = 1;
                        }
                    }
                }
                return e.v++
            }],
            three_cont: ['三连号', (_, a, b = [], e) => {
                return '0123456789'.indexOf(b.sort().join('')) !== -1 ? (e.v = 1) && <i/> : e.v++
            }]
        },
        data: [
            ['三星', [
                ['', [is, lott(0, 1, 2), 'total_val', 'leopard', 'pair', 'all_diff', 'three_cont']],
                [[0, 1, 2], [iss, 1, 2, 3, 4, 5, 6]],
            ]]
        ]
    },
    '3d': {
        k1: x2,
        k2: y,
        data: [
            ['三星', [
                ['', [is, lott(0, 1, 2), 'leopard', 'group_three', 'group_six', 'span']],
                [[0, 1, 2], [iss, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9]],
                ['form', [iss, 'bs_form', 'oe_form', 'pc_form', 'other_form']],
                ['total', [iss, 'total_val', 'mantissa']]
            ]]
        ]
    },
    115: {
        k1: x1,
        k2: y,
        lottery: c => (100 + (+c) + '').substr(1),
        data: [
            ['五星', [
                ['', [is, lott(0, 1, 2, 3, 4)]],
                [[0, 1, 2, 3, 4], [iss, '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11']]
            ]]
        ]
    }
};

const t = {
    /**
     * 重置数据 并初始化视图
     * @param {string} type - 游戏类型(ssc,115,pk10,k3,3d,p35)
     */
    init(type) {
        Object.assign(this, t, {type});
        this.initView();
    },
    act: false,
    ldId: '',
    /*当前数据*/
    data: {},
    /*奖期条数*/
    count: 20,
    /**
     * 获取开奖数据
     * @param {string|number} id - 彩种id
     * @param {number} [count=20] - 取的最近期数
     */
    load(id, count = this.count) {
        if (this.loading && id === this.ldId) return;
        const flush = this.ldId !== id;
        this.ldId = id;
        this.count = count;
        this.loading = true;
        getData('@/trends', {
            lottery_id: id,
            count
        }, (data) => {
            this.loading = false;
            if (!flush && this.data.original_data) {
                const {original_data: od} = this.data;
                const {original_data = []} = data;
                const da = [...original_data];
                od.forEach(o => {
                    if (!da.find(d => d.issue === o.issue)) {
                        da.push(o);
                    }
                });
                data.original_data = da;
            }
            this.data = data
        }, () => {
            this.loading = false;
        }, 'POST')
    },
    loading: false,
    /*视图规则类型*/
    type: '',
    /*选中的一级目录*/
    k0: 0,
    /*选中的二级目录*/
    k1: '',
    /**
     * 获取顶部分类
     * @returns {Array} - 顶部分类名称
     */
    getM1() {
        const cfg = config[this.type];
        if (cfg) {
            return cfg.data.map(k => k[0]);
        } else return []
    },
    /**
     * 获取二级分类
     * @returns {Array} - 二级分类名称
     */
    getM2() {
        const {k0, view} = this;
        if (view) {
            return view[k0].map(({key, name}) => ({
                key, name
            }))
        }
        return [];
    },
    /**
     * Table Column Object.
     * @typedef {Object} Column
     * @property {string} n       - Name of col.
     * @property {function} v     - trans data to cell.
     * @property {function} reset - reset record index.
     *
     * @name Column.v
     * @param {Object} data  - data of each row
     * @return {ReactDOM|string}
     */
    /**
     * 获取表格配置
     * @returns [Column] - 返回表格配置
     */
    getM3() {
        const {view, k1, k0} = this;
        if (view) {
            const f = view[k0].find(o => o.key === k1);
            if (f) {
                return f.columns.map(c => c.reset())
            }
        }
        return [];
    },
    /*当前视图*/
    view: [],
    /*初始化走势模板*/
    initView() {
        const _map = {};
        const cfg = config[this.type];
        const lf = cfg.lottery || (c => +c);
        if (cfg) {
            this.view = cfg.data.map(da => {
                const map = _map;
                const m = [];
                const c = da[1];
                const k = cfg.k1;
                const r = cfg.k2;
                const bd = (a, b) => {
                    return {
                        name: k[a],
                        key: a,
                        columns: b.map(o => {
                            let f = (c, i) => c[i], v;
                            if (Array.isArray(o)) {
                                f = o[1];
                                o = o[0];
                            }
                            let nm = r[o];
                            const col = {v: 1};
                            if (nm) {
                                if (Array.isArray(nm)) {
                                    f = nm[1];
                                    nm = nm[0];
                                }
                                map[o] = map[o] || 0;
                                const i = map[o]++;
                                v = data => f(data[o], i, data.lottery.slice(), col);
                            } else {
                                v = data => {
                                    const nu = data.lottery[this.k1];
                                    if (lf(nu) === lf(o)) {
                                        col.v = 1;
                                        return <b>{lf(nu)}</b>
                                    }
                                    return <span>{lf(col.v++)}</span>
                                }
                            }
                            return {
                                n: nm || o,
                                v,
                                reset() {
                                    col.v = 1;
                                    return this;
                                }
                            }
                        })
                    }
                };
                c.forEach(([a, b]) => {
                    if (Array.isArray(a)) {
                        a.forEach(c => {
                            m.push(bd(c, b))
                        })
                    } else m.push(bd(a, b))
                });
                return m;
            });
        }
    },
};
export const trendsStore = observableStore('_tre',t);
